import CustomerJob from "./CustomerJob"

export default CustomerJob
